import { Modal, Form, IFormContext } from 'rewire-ui';
import { AreaInsertInput }           from '../DataTypes';
import DataMutations                 from '../graphql/Mutations';
import mainPageModel                 from '../main-navigation/MainPageModel';
import { notifications }             from '../ui/Notifications';

export class AddAreaDialogModel extends Modal {
  form: Form;

  constructor() {
    super('Add Area');
    this.form = Form.create((form: IFormContext) => ({
      name: form.string().label('Name').validators('required').placeholder('enter area name').autoFocus(),
    }));
    this.action('cancel')
        .action('save', this.submit, { variant: 'contained', type: 'submit' });
  }

  reset() {
    this.form.reset();
  }

  load() {
    this.reset();
    this.open();
  }

  private save = async (): Promise<boolean> => {
    const areaInput: AreaInsertInput = {
      name:         this.form.field.name.value,
      sharingScope: 'location',
    };
    const result = await DataMutations.insertAreas('', [areaInput]);

    if (result && result[0]) {
      notifications.success('Area Created');
      mainPageModel.updateAreasAndGroups();
      return true;
    }

    notifications.error('Area Creation Failed');
    return false;
  };

  submit = async () => {
    return await this.form.submitAsync(this.save);
  };
}

const addAreaDialogModel = new AddAreaDialogModel();
export default addAreaDialogModel;
